/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HookAction } from './HookAction';
import {
    HookActionFromJSON,
    HookActionFromJSONTyped,
    HookActionToJSON,
} from './HookAction';
import type { HookCondition } from './HookCondition';
import {
    HookConditionFromJSON,
    HookConditionFromJSONTyped,
    HookConditionToJSON,
} from './HookCondition';

/**
 * 
 * @export
 * @interface HookConfiguration
 */
export interface HookConfiguration {
    /**
     * 
     * @type {string}
     * @memberof HookConfiguration
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HookConfiguration
     */
    event_type: string;
    /**
     * 
     * @type {string}
     * @memberof HookConfiguration
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HookConfiguration
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HookConfiguration
     */
    description?: string;
    /**
     * 
     * @type {Array<HookAction>}
     * @memberof HookConfiguration
     */
    actions: Array<HookAction>;
    /**
     * 
     * @type {Array<HookCondition>}
     * @memberof HookConfiguration
     */
    conditions?: Array<HookCondition>;
    /**
     * 
     * @type {boolean}
     * @memberof HookConfiguration
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HookConfiguration
     */
    created_at?: number;
    /**
     * 
     * @type {number}
     * @memberof HookConfiguration
     */
    updated_at?: number;
}

/**
 * Check if a given object implements the HookConfiguration interface.
 */
export function instanceOfHookConfiguration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_type" in value;
    isInstance = isInstance && "actions" in value;

    return isInstance;
}

export function HookConfigurationFromJSON(json: any): HookConfiguration {
    return HookConfigurationFromJSONTyped(json, false);
}

export function HookConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HookConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'event_type': json['event_type'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'actions': ((json['actions'] as Array<any>).map(HookActionFromJSON)),
        'conditions': !exists(json, 'conditions') ? undefined : ((json['conditions'] as Array<any>).map(HookConditionFromJSON)),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
    };
}

export function HookConfigurationToJSON(value?: HookConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'event_type': value.event_type,
        'tenant_id': value.tenant_id,
        'name': value.name,
        'description': value.description,
        'actions': ((value.actions as Array<any>).map(HookActionToJSON)),
        'conditions': value.conditions === undefined ? undefined : ((value.conditions as Array<any>).map(HookConditionToJSON)),
        'enabled': value.enabled,
        'created_at': value.created_at,
        'updated_at': value.updated_at,
    };
}

